<template>
  <div>
    <label class="labelRequiredField">
      {{ label }}
      <span class="mandatory-data">*</span>
      <b-form-text v-if="information">{{ information }}</b-form-text>
    </label>
  </div>
</template>

<script>
export default {
  name: "LabelRequiredField",
  props: {
    label: String,
    information: Boolean,
  },
};
</script>

<style>
.labelRequiredField {
  font-size: 16px;
  color: #333;
}
.mandatory-data {
  font-size: 13px;
  color: #f00;
  padding: 0px !important;
}
</style>